// removed by extract-text-webpack-plugin
module.exports = {"active":"magazines_3UTm-","inactive":"magazines_3lNDs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/FontLink/styles.scss
// module id = 1119
// module chunks = 1